import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { LocalRepository } from "@shared/helper/local-repository";
import { ServiceResult } from "@shared/helper/service-result";
import { TServiceResult } from "@shared/helper/t-service-result";
import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { PublisherModel, publisherReq, transferPublisherModel } from "@app/pages/publisher/models/publisher-model";
import { Observable } from "rxjs";
import { HttpBaseService } from "@shared/service/base_services/http_base.service";
import { ISuggestedPublisherDto } from "@shared/model/suggested-user/suggested-user.model";

@Injectable({
  providedIn: "root"
})

export class PublisherAggrigatorService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/pubAggr');
  }

  transformBookOfPublisher(publsiher: transferPublisherModel): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.apiUrl}/ChangePublisherOfBook`, publsiher);
  }

  comparsionTwopublishers(idies: string[]): Observable<TServiceResult<PageList<PublisherModel>>> {
    return this.http.post<TServiceResult<PageList<PublisherModel>>>(`${this.apiUrl}/ComparePublishers`, idies);
  }

  mergeTwopublishers(publsiher: transferPublisherModel): Observable<TServiceResult<string>> {
    return this.http.post<TServiceResult<string>>(`${this.apiUrl}/ConvertTwoPublisher`, publsiher);
  }

  getGuestPublisherById(id: string): Observable<TServiceResult<PublisherModel>> {
    return this.http.get<TServiceResult<PublisherModel>>(`${this.apiUrl}/GetGuestPublisher/${id}`);
  }


  addPublisherRequestByUser(publisher: publisherReq): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.apiUrl}/AddPublisherRequestByUser`, publisher);
  }

  getActivePublishers(): Observable<TServiceResult<PageList<ISuggestedPublisherDto>>> {
    return this.http.get<TServiceResult<PageList<ISuggestedPublisherDto>>>(`${this.apiUrl}/GetActivePublishers`)
  }

  GetActivePublishersLanding(): Observable<TServiceResult<PageList<ISuggestedPublisherDto>>> {
    return this.http.get<TServiceResult<PageList<ISuggestedPublisherDto>>>(`${this.apiUrl}/GetActivePublishersLanding`)
  }
}

